import { render, staticRenderFns } from "./StatisticalChart.vue?vue&type=template&id=10a28481&scoped=true"
import script from "./StatisticalChart.vue?vue&type=script&lang=js"
export * from "./StatisticalChart.vue?vue&type=script&lang=js"
import style0 from "./StatisticalChart.vue?vue&type=style&index=0&id=10a28481&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a28481",
  null
  
)

export default component.exports